/* eslint-disable no-console */

import * as Sentry from '@sentry/browser';

let doLog = false;

let projectId = '5843250';
const key = '87231e7902dd4769a30437e0d97ba756';

export const init = () => {
  if (window.location.hostname !== 'localhost') {
    doLog = true;
    console.log('initialising logging');
    Sentry.init({
      dsn: `https://${key}@o385345.ingest.sentry.io/${projectId}`,
      tracesSampleRate: 1.0
    });
  }
};

export const captureException = (error) => {
  if (doLog) {
    console.log(error.toString());
    Sentry.captureException(error);
  } else {
    console.log(error);
  }
};
